import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useRef } from 'react';
import { Button } from "../../Button/Button/Button";
import { IconButton } from "../../Button/IconButton/IconButton";
import { MobileMenu } from "../MobileMenu/MobileMenu";
import { Slideout } from "../../Slideout/Slideout";
import { Image } from "../../Image/Image/Image";
import styles from "./MobileMenuSlideout.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MobileMenuSlideout = function MobileMenuSlideout(_ref) {
  var _ref$closeLabel = _ref.closeLabel,
    closeLabel = _ref$closeLabel === void 0 ? 'Click to close.' : _ref$closeLabel,
    _ref$closeSubMenuLabe = _ref.closeSubMenuLabel,
    closeSubMenuLabel = _ref$closeSubMenuLabe === void 0 ? 'Click to close {{link}} submenu' : _ref$closeSubMenuLabe,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {} : _ref$cta,
    _ref$openLabel = _ref.openLabel,
    openLabel = _ref$openLabel === void 0 ? 'Click to open.' : _ref$openLabel,
    _ref$openSubMenuLabel = _ref.openSubMenuLabel,
    openSubMenuLabel = _ref$openSubMenuLabel === void 0 ? 'Click to open {{link}} submenu' : _ref$openSubMenuLabel,
    _ref$logo = _ref.logo,
    logo = _ref$logo === void 0 ? {
      icon: {
        source: {
          url: '',
          xml: ''
        },
        height: ''
      },
      label: '',
      url: ''
    } : _ref$logo,
    _ref$menuItems = _ref.menuItems,
    menuItems = _ref$menuItems === void 0 ? {
      primary: [],
      secondary: []
    } : _ref$menuItems,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? function () {} : _ref$onOpen,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var slideout = useRef(null);
  var open = function open() {
    var _slideout$current;
    setIsOpen(true);
    slideout === null || slideout === void 0 ? void 0 : (_slideout$current = slideout.current) === null || _slideout$current === void 0 ? void 0 : _slideout$current.openSlideout();
  };
  var mobileOnClose = function mobileOnClose() {
    setIsOpen(false);
    onClose();
  };
  var renderMobileLogo = function renderMobileLogo() {
    var _icon$source;
    var _ref2 = logo || {},
      icon = _ref2.icon,
      label = _ref2.label,
      url = _ref2.url;
    return /*#__PURE__*/_jsx(Button, {
      accessibilityLabel: label,
      type: "no-style",
      url: url,
      children: /*#__PURE__*/_jsx(Image, {
        src: (icon === null || icon === void 0 ? void 0 : (_icon$source = icon.source) === null || _icon$source === void 0 ? void 0 : _icon$source.url) || '',
        height: (icon === null || icon === void 0 ? void 0 : icon.height) || '40px',
        width: "100%",
        className: styles.logo,
        loading: "eager"
      })
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      "aria-label": openLabel,
      "aria-haspopup": true,
      icon: "hamburger",
      onClick: open,
      size: "24px",
      "aria-expanded": isOpen
    }), /*#__PURE__*/_jsx(Slideout, {
      closeLabel: closeLabel,
      ref: slideout,
      logo: renderMobileLogo(),
      onOpen: onOpen,
      onClose: mobileOnClose,
      children: /*#__PURE__*/_jsx(MobileMenu, {
        cta: cta,
        primary: menuItems === null || menuItems === void 0 ? void 0 : menuItems.primary,
        secondary: menuItems === null || menuItems === void 0 ? void 0 : menuItems.secondary,
        closeSubMenuLabel: closeSubMenuLabel,
        openSubMenuLabel: openSubMenuLabel
      })
    })]
  });
};